import { render, staticRenderFns } from "./emailInfo.vue?vue&type=template&id=19bc023c&scoped=true"
import script from "./emailInfo.vue?vue&type=script&lang=js"
export * from "./emailInfo.vue?vue&type=script&lang=js"
import style0 from "./emailInfo.vue?vue&type=style&index=0&id=19bc023c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bc023c",
  null
  
)

export default component.exports